import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';
import {TabsStore} from 'src/app/core/state';
import {CoreService} from '../../services/core.service';
import {Practice} from '@xmedical/core';
import {PatientSearchComponent} from '../search/search.component';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {map, shareReplay} from 'rxjs/operators';

@Component({
    selector: 'app-top-nav',
    templateUrl: './top-nav.component.html',
    styleUrls: ['./top-nav.component.scss'],
    standalone: false
})

export class AppTopNavComponent implements OnInit, OnDestroy {

  isNotHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => !result.matches),
      shareReplay()
    );

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  isNotTablet$: Observable<any> = this.breakpointObserver.observe(Breakpoints.Tablet)
    .pipe(
      map(result => !result.matches),
      shareReplay()
    );
  isTablet$: Observable<any> = this.breakpointObserver.observe(Breakpoints.Tablet)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );
  @ViewChild('practiceList') practiceList: ElementRef;
  @ViewChild(PatientSearchComponent) patientSearchBox: PatientSearchComponent;

  constructor(private breakpointObserver: BreakpointObserver, private tabsStore: TabsStore, private coreService: CoreService) {
  }

  get selectedPractice(): Practice {
    return this.coreService.selectedPractice();
  }

  get hasTabs(): boolean {
    return this.tabsStore.hasTabs();
  }

  get hasPractices(): boolean {
    return this.coreService.hasPractices();
  }

  get homeLink(): string {
    return this.coreService.configuration.dashboardModuleEnabled ? '/dashboard' : '/';
  }

  get hasNotifications(): boolean {
    return this.coreService.hasNotifications();
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  openSearch() {
    this.patientSearchBox.openSearch();
  }
}
